module.exports = __webpack_public_path__ + "static/media/messages.9fac2b38.svg";